import React, { useState, useEffect, useRef } from "react";
import { Image } from "antd";
import { Carousel as AntdCarousel } from "antd";
import useDetectDevice from "utils/hooks/useWindowSize";
import { ArrowNext, ArrowPrev, GridContainer } from "./styles";
import photo_default from "assets/images/Placeholderimage.webp";
import { IHousePhoto } from "interfaces/intarfaces";

export const Carousel: React.FC<{
  photos: IHousePhoto[] | [];
}> = ({ photos }) => {
  const [pictures, setPictures] = useState<
    { value: string; state: string; label: string }[]
  >([]);
  const [mediaSize, setMediaSize] = useState<number>(3);
  const device = useDetectDevice();
  const sliderRef = useRef<any>(null);
  const { innerWidth: width } = window;

  let colPhoto = device === "mobile" ? 1 : device === "tablet" ? 2 : 3;

  useEffect(() => {
    if (!photos.length)
      setPictures([{ value: photo_default, state: "initial", label: "1" }]);
    setPictures(
      photos.map((item, num) => ({
        value: item.url,
        state: num >= colPhoto ? "none" : "initial",
        label: item.timestamp
      }))
    );
  }, [colPhoto, photos]);

  useEffect(() => {
    if (width <= 768 && width > 570) {
      setMediaSize(2);
    } else if (width <= 570) {
      setMediaSize(1);
    } else {
      setMediaSize(3);
    }
  }, [width]);

  useEffect(() => {
    if (sliderRef.current && pictures.length) {
      setTimeout(() => {
        sliderRef.current.goTo(0);
      }, 200);
    }
  }, [pictures]);

  return (
    <GridContainer>
      {/* <ArrowPrev onClick={() => sliderRef.current.prev()} />
      <ArrowNext onClick={() => sliderRef.current.next()} /> */}
      <Image.PreviewGroup>
        <AntdCarousel infinite={false} slidesToShow={mediaSize} ref={sliderRef}>
          {pictures.map((item, idx) => (
            <Image
              key={idx}
              src={item.value}
              style={{ display: item.state }}
              width={mediaSize === 1 ? "100%" : "95%"}
            />
          ))}
        </AntdCarousel>
      </Image.PreviewGroup>
    </GridContainer>
  );
};
